import { render, staticRenderFns } from "./NotificationListContainer.vue?vue&type=template&id=19cbb25d&"
import script from "./NotificationListContainer.vue?vue&type=script&lang=js&"
export * from "./NotificationListContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports